/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rate_Prompt_QuestionInputs */

const en_rate_prompt_question = /** @type {(inputs: Rate_Prompt_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How would you rate your experience?`)
};

const es_rate_prompt_question = /** @type {(inputs: Rate_Prompt_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo calificarías tu experiencia?`)
};

/**
* | output |
* | --- |
* | "How would you rate your experience?" |
*
* @param {Rate_Prompt_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const rate_prompt_question = /** @type {((inputs?: Rate_Prompt_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rate_Prompt_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_rate_prompt_question(inputs)
	return en_rate_prompt_question(inputs)
});